import { Box, Typography } from '@mui/material';
import css from '../../css/account.module.css';
import {Routes,Route} from 'react-router-dom';
import {Login,ForgotPassword,ChangePassword} from './index';
import Logo from '../../images/logo.png';
// import Passport9 from '../../images/img9.png';
import Passport1 from '../../images/img1.png';
import Passport2 from '../../images/img2.png';
import Passport3 from '../../images/img3.png';
import Passport4 from '../../images/img4.png';
import Ellipse   from '../../images/img5.png';
import line1 from '../../images/line-1.png';
import line2 from '../../images/line-2.png';
import line3 from '../../images/line-3.png';
//api integration 

const Account = (props:any) => {
  const userHasChangePassword = props.data;
  const setUserHasChangePassword = props.onChange;

  return (
    <div className={css.container}>
        <Box component="section">
            <Typography component="div"align='center' sx={{mt:3.5}}>
              <img src={Logo} alt="logo" width="45"/>
              <Typography component="div" sx={{color:"white",fontWeight:"500"}}>
                CIPM Application Admin
              </Typography>
            </Typography>
            <Routes>
              <Route path="/*" element={<Login data={userHasChangePassword} onChange={setUserHasChangePassword}/>}/>
              <Route path="/login" element={<Login data={userHasChangePassword} onChange={setUserHasChangePassword}/>}/>
              <Route path="/forgot-password" element={<ForgotPassword/>}/>
              <Route path="/change-password" element={<ChangePassword/>}/>
            </Routes>
        </Box>
        <Box component="div">
          <img className={css.img1} src={Passport1} width="55"/>
          <img className={css.img2} src={Passport2} width="50"/>
          <img className={css.img3} src={Passport3} width="65"/>
          <img className={css.img4} src={Passport4} width="55"/>
          <img className={css.img5} src={Ellipse} width="120" />
          <img className={css.img6} src={Ellipse} width="120" />
          <img className={css.line1} src={line1} />
          <img className={css.line2} src={line2} />
          <img className={css.line3} src={line3} />
         </Box>

    </div>
  )
}

export default Account